<template>
  <div v-if="banner" class="app-banner">
    <div class="container is-max-desktop">
      <div class="notification my-3 p-3 block" :class="banner.notificationClass">
        <div class="columns is-vcentered">
          <p class="column">{{ banner.message }}</p>
          <div class="column is-narrow">
            <div class="buttons">
              <template v-for="action in banner.actions" :key="action.label">
                <a
                  v-if="action.href"
                  :href="action.href"
                  :class="action.class || ''"
                >{{ action.label }}</a>
                <button
                  v-else
                  :class="action.class || 'button'"
                  @click="action.onClick"
                >{{ action.label }}</button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useBlocksStore } from "../stores/blocks";

const store = useBlocksStore();

const isDemoMode = computed(() => store.userSession?.local);
const isPastDue = computed(() => store.isPastDue);

const banner = computed(() => {
  if (isPastDue.value) {
    return {
      notificationClass: "is-warning is-light",
      message: "Payment issue — Your last payment failed. Please update your billing info to keep your subscription active.",
      actions: [
        { label: "Update billing", onClick: () => store.openBillingPortal(), class: "button is-warning" }
      ]
    };
  }
  if (isDemoMode.value) {
    return {
      notificationClass: "",
      message: "You're in demo mode. Create an account for free to save your timers and more.",
      actions: [
        { label: "Sign in", href: "/signin" },
        { label: "Create account", href: "/signup", class: "button" }
      ]
    };
  }
  return null;
});
</script>
